export default __webpack_public_path__ + "static/media/Bakanov_Dmitry_Vladimirovich.54efe76e.webp";